import { 
    GET_ARTEIMAGES_SUCCESS, 
    TOGGLE_ARTEIMAGES_MORE, 
    ADD_ARTEIMAGES_PAGE, 
    SAVE_ARTEIMAGES_PAGE 
} from "../actions";
import { DELETE_ARTEFILE, GET_ARTEFILES } from "../actions/artefact";

const initialState = {
    page: 1,
    spage: 0,
    hasmore: true,
    isLoading: false,
    files: [],
    errors: null,
    new: {
        isLoading: false,
        isSuccess: false,
        errors: null
    }
}

export const arteFilesReducer = (state = initialState, action) => {
    switch(action.type){
        case GET_ARTEFILES:
            return { 
                ...state, 
                files: action.files, 
                hasmore: false,
                isLoading: false,
                errors: null
            }
        case DELETE_ARTEFILE:
            return { 
                ...state, 
                new: {
                    isLoading: false,
                    isSuccess: true,
                    errors: null
                }
            }

        default: return state
        // case ADD_ARTEIMAGES_PAGE:
        //     return { ...state, loading: true, page: state.page + 1 }
        // case SAVE_ARTEIMAGES_PAGE:
        //     return { ...state, spage: state.page }
        // case GET_ARTEIMAGES_SUCCESS:
        //     //return { ...state, images: [...state.images, ...action.images] }
        //     return { ...state, images: action.images }
        // case TOGGLE_ARTEIMAGES_MORE:
        //     //return { ...state, images: [...state.images, ...action.images], hasmore: false }
        //     return { ...state, images: action.images, hasmore: false }
        
    }
}